export function isReduxThunkPendingAction(sliceName, actionType) {
    return actionType.startsWith(sliceName) && actionType.endsWith('pending')
}

export function isReduxThunkRejectedAction(sliceName, actionType) { 
    return actionType.startsWith(sliceName) && actionType.endsWith('rejected')
}

export const getReduxActionErrorMessage = (action) => {
    if (action.payload) {
        if (action.payload.message) {
            return action.payload.message;
        } else if (action.payload.title) {
            return action.payload.title;
        }
    }

    return action.error.message
}